<div class="">
   <div class="contentBox">
      <ul class="brand-details-list team-list font-16">
         <li>
            <div class="person-pic">
               <div class="icon pic margin-b-20 wow fadeInUp" data-wow-duration="500ms" data-wow-delay="50ms">
                  <img src="assets/images/saurabh.jpg" alt="">
               </div>
               <div class="margin-b-30 wow fadeInUp" data-wow-duration="500ms" data-wow-delay="100ms">
                  <div class="font-17 proximaNovaSb">Saurabh Mittal</div>
                  <div class="font-14 light-color proximaNovaSb">Founder & Chairman</div>
               </div>
               <div class="social-media flex wow fadeInUp" data-wow-duration="500ms" data-wow-delay="150ms">
                  <!--                  <a href="#" class="icon">-->
                  <!--                     <img src="assets/images/twitter.png" alt="">-->
                  <!--                  </a>-->
                  <a href="https://www.linkedin.com/in/saurabh-mittal-mission/" target="_blank" class="icon">
                     <img src="assets/images/linkedin.png" alt="">
                  </a>
               </div>
            </div>
            <div class="person-details line-25">
               <div class="margin-b-15 wow fadeInUp" data-wow-duration="500ms" data-wow-delay="50ms">
                  Saurabh K. Mittal is Chairman, CEO and Founder of Mission
                  Holdings, a strategic holdings business and investment business.
                  Mr. Mittal has been involved in all phases of Mission Holdings&#39;
                  development since its founding in 2014.
               </div>
               <div class="margin-b-15 wow fadeInUp" data-wow-duration="500ms" data-wow-delay="150ms">
                  Mission Holdings has invested in or created leading platforms
                  across industries and serves as core long term shareholder
                  helping drive long term value creation. The firm’s core platforms
                  include Incedo Inc, a leading data and AI solutions business; ONE
                  Championship, one of the world&#39;s largest sports leagues; BSI
                  Financial, a leading player in US residential mortgage; Everstone
                  Holdings, India&#39;s leading alternates and infrastructure business;
                  and Deserve Inc, a leading modern credit card stack.
               </div>
               <div class="margin-b-15 wow fadeInUp" data-wow-duration="500ms" data-wow-delay="150ms">
                  Mission Holdings, through Mission Capital, a wholly owned
                  investment entity, has a diversified and active portfolio invested
                  across the capital structure including specialized debt, private
                  equity deals and public markets, as well as with specialized fund
                  managers.
               </div>
               <div class="margin-b-15 wow fadeInUp" data-wow-duration="500ms" data-wow-delay="150ms">
                  Prior to founding Mission Holdings, Mr Mittal was a co-founder of
                  Indiabulls Group and a partner at Noonday Asset Management
                  (part of Farallon Capital).
               </div>
               <div class="margin-b-15 wow fadeInUp" data-wow-duration="500ms" data-wow-delay="150ms">
                  Mr. Mittal received a degree in Electrical Engineering from Indian
                  Institute of Technology, Delhi, India where he was elected as the
                  Best Graduating Student of his class, and recipient of
                  Distinguished Alumni Award in 2017. He also holds an MBA with
                  High Distinction from the Harvard Business School, where he
                  graduated as a Baker Scholar.
               </div>
               <div class="margin-b-15 wow fadeInUp" data-wow-duration="500ms" data-wow-delay="150ms">
                  Mr. Mittal serves on the Board of Dean’s Advisors at Harvard
                  Business School, and the Endowment Board at IIT Delhi; is
                  Trustee and Founder of Plaksha University; and a member of
                  governing council of Avsara. He has served on the governing
                  board of Paarivar Education in the past, and is currently member
                  of Advisory Board.
               </div>
               <div class="margin-b-15 wow fadeInUp" data-wow-duration="500ms" data-wow-delay="150ms">
                  Mr. Mittal is an active philanthropist with a history of supporting
                  education. In both business and philanthropy, Mr. Mittal has
                  dedicated himself to helping improve access to opportunities for
                  young students, and believes in holistic development that includes
                  Leadership, Academics and Sports. Mr Mittal gifted the Mittal
                  Sports Center at IIT Delhi which was inaugurated in Sep 2021. He
                  has also created “Mittal Scholars” program at IIT Delhi to identify
                  business leaders of tomorrow with an annual cohort of 40
                  students. “Mittal Fellows” at Harvard Business School and Plaksha
                  Univ provide opportunities to highly talented students to pursue
                  higher education at world leading institutions, while “Mittal Center
                  of Indian Studies” at Avsara Academy and “Mittal Residential
                  blocks” at Paarivar Education Academy help broaden access to
                  education.
               </div>
            </div>
         </li>
      </ul>
   </div>
</div>
